module.exports = __webpack_public_path__ + "img/excel-format-screen-shot-1.68e9139d.png";